import { from, Observable } from "rxjs";
import { apiClient } from "./api";
import { ENDPOINTS } from "@/settings/api-settings";
import { map } from "rxjs/operators";
import { PessoaFisicaFiltroParmDTO } from "@/interfaces/individuals";

export function listIndividualsCombo(parm: PessoaFisicaFiltroParmDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.INDIVIDUALS_COMBO, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}